import { Reveal } from "./Reveal";

export default function PageHeader({ overline, title, subtitle }) {
  return (
    <section className="pt-36 md:pt-44 pb-12 md:pb-16 bg-brand text-brand-cream relative overflow-hidden">
      <div className="absolute inset-0 grain-overlay" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <Reveal>
          {overline && <p className="font-outfit text-xs uppercase tracking-[0.2em] text-brand-accent font-bold mb-4">{overline}</p>}
          <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-none max-w-3xl">{title}</h1>
          {subtitle && <p className="font-figtree text-lg text-brand-cream/70 mt-5 max-w-2xl">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
